<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />

        <div class="my-4">
            <h2>
                Đơn hàng
            </h2>

            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'code',
    headerName: $t('labels.order'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'productivityOrder',
    headerName: $t('labels.productivity'),
    valueGetter: (params: any) => {
      const { productivityOrder } = params.data
      return $formatters.formatNumber(productivityOrder || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'commodityName',
    headerName: $t('labels.commodity'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'customerName',
    headerName: $t('labels.customer'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'saleName',
    headerName: $t('labels.staffSale'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'quoteCode',
    headerName: $t('labels.quote'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'workflowName',
    headerName: $t('labels.workflow'),
    filter: 'agTextColumnFilter'
  },
  {
    field: 'revenue',
    headerName: $t('labels.revenue'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.revenue || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'cost',
    headerName: $t('labels.cost'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.cost || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'profit',
    headerName: $t('labels.profit'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.profit || 0)
    },
    filter: 'agNumberColumnFilter'
  },
  {
    field: 'commission',
    headerName: $t('labels.commission'),
    valueGetter: (params: any) => {
      const { pricingEstimate } = params.data
      return $formatters.formatNumber(pricingEstimate?.commission || 0)
    },
    filter: 'agNumberColumnFilter'
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = async () => {
  items.value = []
  const data = await $api($url.report.getOrder, { body: filters.value })
  const responseData: any = data?.data?.value
  if (responseData?.success) {
    items.value = responseData.data
  } else {
    items.value = []
  }
  loading.value = false
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
